import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Icon, makeStyles } from '@popmenu/common-ui';
import { AppleIcon, FacebookIcon, GoogleIcon } from '@popmenu/web-icons';
import { type SocialProvider, useSocialSignIn } from '../../hooks/useSocialSignIn';

type SocialSignInButtonsProps = {
  returnTo: string
}

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5, 2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}));

const PROVIDERS: { icon: typeof GoogleIcon, label: React.ReactNode, provider: SocialProvider }[] = [
  {
    icon: GoogleIcon,
    label: <FormattedMessage defaultMessage="Continue with Google" />,
    provider: 'google',
  },
  {
    icon: AppleIcon,
    label: <FormattedMessage defaultMessage="Continue with Apple" />,
    provider: 'apple',
  },
  {
    icon: FacebookIcon,
    label: <FormattedMessage defaultMessage="Continue with Facebook" />,
    provider: 'facebook',
  },
];

export const SocialSignInButtons = ({ returnTo }: SocialSignInButtonsProps) => {
  const classes = useStyles();
  const { loading, startSocialSignIn } = useSocialSignIn();

  return (
    <Box className={classes.container}>
      {PROVIDERS.map(({ icon, label, provider }) => (
        <Button
          key={provider}
          className={classes.button}
          disabled={loading}
          fullWidth
          onClick={() => startSocialSignIn(provider, returnTo)}
          startIcon={<Icon icon={icon} />}
          variant="outlined"
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};
